import {
  ClockCircleOutlined,
  EnvironmentOutlined,
  FontSizeOutlined,
  InstagramOutlined,
  SoundOutlined,
  TagOutlined,
} from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Gallery from '@components/gallery/Gallery'
import { useHasAccess } from '@components/HasAccess'
import Menu from '@components/menu/Menu'
import Page from '@components/Page/Page'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { Col, Flex } from 'antd'

const CustomizeTab = () => {
  const { hasAccess } = useHasAccess()

  return (
    <Page rowGutter={[32, 32]} noWrapWithCol>
      <Col span={12}>
        <Flex vertical gap={32}>
          <FormCard
            // multilingual
            title="Description"
            icon={<FontSizeOutlined />}
            entity={Entity.venue}
            action={SBRMAction.Update}
            sections={['description']}
            disabled={!hasAccess(Permission.updateVenue)}
          />
          <FormCard
            // multilingual
            title="Schedules"
            icon={<ClockCircleOutlined />}
            entity={Entity.venue}
            action={SBRMAction.Update}
            sections={['schedule']}
            disabled={!hasAccess(Permission.updateVenue)}
          />
          <FormCard
            // multilingual
            title="Map"
            icon={<EnvironmentOutlined />}
            entity={Entity.venue}
            action={SBRMAction.Update}
            sections={['map']}
            disabled={!hasAccess(Permission.updateVenue)}
          />
          <FormCard
            title="Musics"
            icon={<SoundOutlined />}
            entity={Entity.venue}
            action={SBRMAction.Update}
            sections={['musics']}
            disabled={!hasAccess(Permission.updateVenue)}
          />
        </Flex>
      </Col>
      <Col span={12}>
        <Flex vertical gap={32}>
          <Gallery.Card />
          <Menu.Card />
          <FormCard
            title="Tags"
            icon={<TagOutlined />}
            entity={Entity.venue}
            action={SBRMAction.Update}
            sections={['tags']}
            disabled={!hasAccess(Permission.updateVenue)}
          />
          <FormCard
            title="Socials"
            icon={<InstagramOutlined />}
            entity={Entity.venue}
            action={SBRMAction.Update}
            sections={['socials']}
            disabled={!hasAccess(Permission.updateVenue)}
          />
        </Flex>
      </Col>
    </Page>
  )
}

export default CustomizeTab
